import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";

// Admin Components
import AdminLogin from "./components/admin/AdminLogin";
import AdminLayout from "./components/admin/AdminLayout";
import AdminReferrals from "./components/admin/AdminReferrals";
import AdminServices from "./components/admin/AdminServices";
import AdminContacts from "./components/admin/AdminContacts";
import AdminUsers from "./components/admin/AdminUsers";

// CRM Components
import CrmDashboard from "./components/admin/crm/CrmDashboard";
import CrmLeads from "./components/admin/crm/CrmLeads";
import CrmReferralSources from "./components/admin/crm/CrmReferralSources";
import CrmTasks from "./components/admin/crm/CrmTasks";
import CrmReports from "./components/admin/crm/CrmReports";

const App = () => {
  return (
    <Routes>
      {/* Admin Routes */}
      <Route path="/admin/auth/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Navigate to="crm/dashboard" replace />} />
        <Route path="dashboard" element={<Navigate to="crm/dashboard" replace />} />
        <Route path="users" element={<AdminUsers />} />
        
        {/* CRM Module */}
        <Route path="crm">
          <Route path="dashboard" element={<CrmDashboard />} />
          <Route path="leads" element={<CrmLeads />} />
          <Route path="referral-sources" element={<CrmReferralSources />} />
          <Route path="tasks" element={<CrmTasks />} />
          <Route path="reports" element={<CrmReports />} />
        </Route>

        <Route path="referrals" element={<AdminReferrals />} />
        <Route path="services" element={<AdminServices />} />
        <Route path="contacts" element={<AdminContacts />} />
      </Route>
      
      {/* Redirect root to admin login */}
      <Route path="/" element={<Navigate to="/admin/auth/login" replace />} />
    </Routes>
  );
};

export default App;
